export default __webpack_public_path__ + "static/media/lg-f.8718b410.jpg";